import { BotdesignerContact } from "../core";

export type GupshupContact = BotdesignerContact;

    // {
    //     "app": "DemoAPI",
    //     "timestamp": 1580546677791,
    //     "version": 2,
    //     "type": "billing-event",
    //     "payload": {
    //       "deductions": {
    //         "type": "FEP/UIC/BIC",
    //         "model": "NBP/CBP",
    //         "source": "whatsapp"
    //       },
    //       "references": {
    //         "id": "59f8db90c37e-4408-90ab-cc54ef8246ad",
    //         "gsId": "ee4a68a0-1203-4c85-8dc3-49d0b3226a35",
    //         "conversationId": "532b57b5f6e63595ccd74c6010e5c5c7",
    //         "destination": "91XX985XX10X"
    //       }
    //     }
    // }

export enum DeductionType {
    FEP = 'FEP',
    UIC = 'UIC',
    BIC = 'BIC',
} 

export enum DeductionModel {
    NBP = 'NBP',
    CBP = 'CBP',
}
export interface GupshupPayload {
    id: string;
    source: string,
    type: 'text' | 'audio' | 'mismatch' | 'video' | 'image' | 'file' | 'sent' | 'read' | 'delivered' | 'enqueued' | 'failed' | 'sticker' | 'contact' | 'button_reply' | 'quick_reply' | 'list_reply' | 'reaction',
    payload: {
        text?: string;
        caption?: string;
        url?: string;
        urlExpiry?: number;
        code?: number;
        contacts?: GupshupContact[];
        postbackText?: string;
        title?: string;
        phone?: string;
        wa_id?: string;
        id?: string;
        gsId?: string;
        emoji?: string;
    },
    destination?: string;
    sender: {
        phone: string;
        name: string;
    },
    gsId?: string;
    context: {
        gsId: string;
        id: string;
    },
    deductions?: {
        type: DeductionType;
        model: DeductionModel;
        source: "whatsapp"
    },
    references?: {
        id: string;
        gsId: string;
        conversationId: string;
        destination: string;
    },
    elementName?: string;
    status?: string;
    rejectedReason?: string;
    category?: {new: string, old: string} | string;
    referral?: {
        body: string;
        headline: string;
        image?: {
            id: string;
        },
        video?: {
            id: string;
        },
        source_id: string;
        source_type: string;
        source_url: string;
    }
}
export enum GupshupMessageType {
    'message' = 'message',
    'user-event' = 'user-event',
    'message-event' = 'message-event',
    'billing-event' = 'billing-event'
}
export interface GupshupMessage {
    app: string;
    timestamp: number;
    version: number;
    type: GupshupMessageType;
    payload: GupshupPayload;
}